type SearchQuery = { wpid: string }

export default defineNuxtRouteMiddleware(async (to) => {
  const pharmacySwitch = usePharmacySwitchStore()

  const { wpid: wpidString } = to.query as SearchQuery

  if (wpidString) {
    const wpid = Number(wpidString)
    if (!isNaN(wpid))
      pharmacySwitch.fromWpid(wpid)
  }
})
